import {nanoid} from 'nanoid';
class SnackbarUtils {
    _actionCallback;
    _id;

    constructor() {
        this.DEFAULT_SNACKBAR_OPTIONS = {
            level: 'success',
            duration: 5000,
            closable: true,
            action: {},
        };
        this.triggerAnyAction = this.triggerAnyAction.bind(this);
    }

    fallbackFunction() {
        return {};
    }

    getSnackbar() {
        return document.getElementById(this._id);
    }

    bindListeners() {
        this.getSnackbar().addEventListener('joy-snackbar-trigger-action', this.triggerAnyAction);
    }

    triggerAnyAction(event) {
        clearTimeout(this._timeout);
        this._actionCallback();
        this.destroyCurrentSnackbar();
    }

    formatDefaultOptions(opts) {
        const action = {};
        if (opts.action && opts.action.text) {
            action.text = opts.action.text;
        }

        return {
            level: opts.level || this.DEFAULT_SNACKBAR_OPTIONS.level,
            duration: opts.duration || this.DEFAULT_SNACKBAR_OPTIONS.duration,
            closable: opts.closable !== undefined ? opts.closable : this.DEFAULT_SNACKBAR_OPTIONS.closable,
            action,
        };
    }

    createSnackbar(message, options) {
        const snackbar = document.createElement('joy-snackbar');

        this._id = 'joy-snackbar_' + nanoid();
        snackbar.setAttribute('id', this._id);
        snackbar.setAttribute('level', options.level);
        snackbar.setAttribute('dangerous-html-message', message);
        snackbar.setAttribute('closable', options.closable);
        snackbar.setAttribute('duration', options.duration);

        options.header && snackbar.setAttribute('header', options.header);
        options.action.text && snackbar.setAttribute('action-text', options.action.text);

        document.body.appendChild(snackbar);
    }

    deleteAllSnackbars() {
        Array.from(document.querySelectorAll('joy-snackbar')).forEach((snackbar) => {
            snackbar.remove();
        });
    }

    destroyCurrentSnackbar() {
        this.getSnackbar().classList.add('joy-snackbar--hiding');

        setTimeout(() => {
            this.getSnackbar().remove();
        }, 1000);
    }

    pushNotification(message, options = {}) {
        const defaultOptions = this.formatDefaultOptions(options);
        Object.assign(options, defaultOptions);

        this.deleteAllSnackbars();
        this.createSnackbar(message, options);

        /**
         * If you need to "cancel" an action anywhere, you can pass a triggerActionText option which contains a simple text to add in the Snackbar.
         * Use action.callback option to give a function that will be triggered clicking on the CTA created by actionText param.
         */
        if (options.action.text) {
            this._actionCallback = options.action.callback || this.fallbackFunction;
        }

        this.bindListeners();
    }
}

export default new SnackbarUtils();
